import { css } from 'lit';
export default css `
  wui-loading-spinner {
    margin: 9px auto;
  }

  .email-display,
  .email-display wui-text {
    max-width: 100%;
  }
`;
//# sourceMappingURL=styles.js.map